import React, { useState, useEffect } from 'react';
import { PageContainer, ButtonLoading, Icons, InputCurrency } from 'components';
import { useNavigate, useParams } from 'react-router-dom';
import { useForm, FormProvider } from 'react-hook-form';
import { Grid, Button } from '@mui/material';
import createToast from 'components/Toast/Toast';
import SubsetServices from '../../services/SubsetServices';
import { useQuery } from 'hooks';
import { constBreadCrumbsTitle } from 'utility';
import { useCurrencyUnit } from 'hooks';
const BranchFinancial = () => {
  const query = useQuery();
  const methods = useForm();
  const naviage = useNavigate();
  const params = useParams();
  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState('');
  const [isImprest, setIsImprest] = useState(false);
  const currencyText = useCurrencyUnit()
  
  useEffect(() => {
    const imprest = query?.get('imprest');
    if (imprest) {
      setIsImprest(true);
    }
    setLoading(true);
    SubsetServices.getBusinessfinancialInfo({ branchId: params.id })
      .then((res) => {
        setFormData(res.result);
        setTitle(res.result.businessSoftSrv.name);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  /**
   * چک میکند فیلدهای داخل آبجکت مقدار داشته باشد و اگر نداشته باشد از داخل آبجکت حذف میشود
   */
  const onCheckObjectClean = (values) => {
    for (var key in values) {
      if (values.hasOwnProperty(key)) {
        if (!values[key] || values[key] == '' || values[key] == null || values[key] == undefined) {
          delete values[key];
        }
      }
    }
  };

  const onSubmit = async () => {
    setLoading(true);
    const values = methods.getValues();
    onCheckObjectClean(values);
    SubsetServices.changeBusinessfinancialInfo(params.id, { ...values })
      .then((res) => {
        setLoading(false);
        createToast('موفق', 'با موفقیت انجام شد', 'success');
        naviage(`${isImprest == true ? '/Imprest' : '/Branch'}`);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const getKeyBreadCrumbsWithUrl = () => {
    if (isImprest === null || isImprest === undefined) return null;

    return isImprest === true
      ? constBreadCrumbsTitle.IMPREST_FINANCIAL
      : constBreadCrumbsTitle.BRANCH_FINANCIAL;
  };
  return (
    <PageContainer
      title={`${isImprest == true ? 'سقف مالی تنخواه گردان' : 'سقف مالی  شعبه'}  ${title} `}
      breadcrumbs={getKeyBreadCrumbsWithUrl()}
      loading={loading}
      meta={
        <Button
          color="primary"
          variant="outlined"
          endIcon={<Icons icon="CaretLeft" color="#2b3990" size="25" />}
          onClick={() => naviage(`${isImprest == true ? '/Imprest' : '/Branch'}`)}
        >
          بازگشت به لیست {isImprest == true ? 'تنخواه گردان' : 'شعبه ها'}
        </Button>
      }
    >
      <FormProvider {...methods}>
        {!loading && (
          <form onSubmit={methods.handleSubmit(onSubmit)} noValidate autoComplete="off">
            <Grid container spacing={3}>
              <Grid direction="row" spacing={3} container item xs={12} md={12} lg={7}>
                <Grid item md={6} xs={12}>
                  <InputCurrency
                    fullWidth
                    label={`حداکثر مبلغ قابل برداشت از حساب پاد، و انتقال به شبا یا کارت خود در روز (${currencyText})`}
                    errors={methods.formState.errors}
                    name="maxCashOutMySelfDailyLimit"
                    control={methods.control}
                    register={methods.register}
                    defaultValue={formData?.maxCashOutMySelfDailyLimit}
                    dir="ltr"
                    currency
                    decimalPlaces={0}
                    minimumValue={0}
                    rules={['isNumeric']}
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <InputCurrency
                    fullWidth
                    label={`حداکثر مبلغ قابل برداشت از حساب پاد، و انتقال به شبا یا کارت دیگران در روز (${currencyText})`}
                    errors={methods.formState.errors}
                    name="maxCashOutToOtherDailyLimit"
                    control={methods.control}
                    register={methods.register}
                    defaultValue={formData?.maxCashOutToOtherDailyLimit}
                    dir="ltr"
                    currency
                    decimalPlaces={0}
                    minimumValue={0}
                    rules={['isNumeric']}
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <InputCurrency
                    fullWidth
                    label={`حداکثر مبلغ قابل انتقال به کاربر دیگر در روز (${currencyText})`}
                    errors={methods.formState.errors}
                    name="maxTransferDailyLimit"
                    control={methods.control}
                    register={methods.register}
                    defaultValue={formData?.maxTransferDailyLimit}
                    dir="ltr"
                    currency
                    decimalPlaces={0}
                    minimumValue={0}
                    rules={['isNumeric']}
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <InputCurrency
                    fullWidth
                    label={`حداکثر مبلغ در روز برای افزایش موجودی (${currencyText})`}
                    errors={methods.formState.errors}
                    name="maxCashInDailyLimit"
                    control={methods.control}
                    register={methods.register}
                    defaultValue={formData?.maxCashInDailyLimit}
                    dir="ltr"
                    currency
                    decimalPlaces={0}
                    minimumValue={0}
                    rules={['isNumeric']}
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <InputCurrency
                    fullWidth
                    label={`حداکثر مبلغ قابل استفاده برای خرید در روز (${currencyText})`}
                    errors={methods.formState.errors}
                    name="maxPurchaseDailyLimit"
                    control={methods.control}
                    register={methods.register}
                    defaultValue={formData?.maxPurchaseDailyLimit}
                    dir="ltr"
                    currency
                    decimalPlaces={0}
                    minimumValue={0}
                    rules={['isNumeric']}
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <InputCurrency
                    fullWidth
                    label={`حداکثر مبلغ هر تراکنش (${currencyText})`}
                    errors={methods.formState.errors}
                    name="maxTransactionLimit"
                    control={methods.control}
                    register={methods.register}
                    defaultValue={formData?.maxTransactionLimit}
                    dir="ltr"
                    currency
                    decimalPlaces={0}
                    minimumValue={0}
                    rules={['isNumeric']}
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <InputCurrency
                    fullWidth
                    label={`حداکثر مبلغ صدور فاکتور در روز (${currencyText})`}
                    errors={methods.formState.errors}
                    name="maxIssueInvoiceLimit"
                    control={methods.control}
                    register={methods.register}
                    defaultValue={formData?.maxIssueInvoiceLimit}
                    dir="ltr"
                    currency
                    decimalPlaces={0}
                    minimumValue={0}
                    rules={['isNumeric']}
                  />
                </Grid>
              </Grid>
              <Grid direction="row" container item xs={12} justifyContent="flex-end">
                <ButtonLoading type="submit" variant="contained" color="primary" name="ثبت" />
              </Grid>
            </Grid>
          </form>
        )}
      </FormProvider>
    </PageContainer>
  );
};
export default BranchFinancial;
